import React from 'react'
import PropTypes from 'prop-types'
import { Box, Button, ButtonBase, CircularProgress, Collapse, Stack, Typography } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useSmartTranslation } from '../../../../../../../generic/hooks/useSmartTranslation'
import { FOOTPRINT_DETAIL_STATUS } from '../../../hooks/usePartFootprintDetail'

// Historia 169 (RN28, A7, CU2-CU3) — la fila compartida de MATERIALES/INSPECCIÓN (UX-10, 2026-09-26:
// retiradas INTENTOS/CONTEXTO, que vivían aquí — Jupiter ya no las pide ni las pinta): resumen siempre
// visible + botón desplegar (objetivo táctil ≥ 48 px, `aria-expanded`) + el detalle bajo demanda
// (cargando / error con "Reintentar" / contenido), sin tocar el resto del panel (S74/S77).

const FootprintExpandableRow = ({
  block = '',
  labelKey = '',
  summary = null,
  expanded = false,
  status = FOOTPRINT_DETAIL_STATUS.IDLE,
  errorKey = '',
  onToggle = () => {},
  onRetry = () => {},
  children = null
}) => {
  const { t_ } = useSmartTranslation()
  return (
    <Box data-testid={'footprint-row-' + block} sx={{ borderTop: 1, borderColor: 'divider' }}>
      <ButtonBase
        onClick={onToggle}
        aria-expanded={expanded}
        sx={{
          width: '100%',
          minHeight: 48,
          minWidth: 48,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
          px: 2,
          py: 1,
          textAlign: 'left'
        }}
      >
        <Typography sx={{ fontWeight: 800, flexShrink: 0 }}>{t_(labelKey)}</Typography>
        <Box sx={{ flexGrow: 1, minWidth: 0 }}>{summary}</Box>
        <ExpandMoreIcon sx={{ transform: expanded ? 'rotate(180deg)' : 'none', transition: 'transform 120ms' }} />
      </ButtonBase>
      <Collapse in={expanded} unmountOnExit>
        <Box data-testid={'footprint-detail-' + block} sx={{ px: 2, pb: 2 }}>
          {status === FOOTPRINT_DETAIL_STATUS.LOADING || status === FOOTPRINT_DETAIL_STATUS.IDLE
            ? <Stack alignItems='center' sx={{ py: 2 }}><CircularProgress size={24} aria-label={t_('Loading')} /></Stack>
            : null}
          {status === FOOTPRINT_DETAIL_STATUS.FAILED
            ? (
              <Stack alignItems='center' spacing={1.5} sx={{ py: 2 }} role='alert' data-testid={'footprint-detail-error-' + block}>
                {/* RN28/E-F1: siempre el mensaje genérico dentro de la fila, sin importar el literal exacto. */}
                <Typography color='error'>{t_('This block could not be loaded')}</Typography>
                <Button variant='outlined' onClick={onRetry} sx={{ minHeight: 48, minWidth: 48 }}>{t_('Retry')}</Button>
              </Stack>
              )
            : null}
          {status === FOOTPRINT_DETAIL_STATUS.READY ? children : null}
        </Box>
      </Collapse>
    </Box>
  )
}

FootprintExpandableRow.propTypes = {
  block: PropTypes.string,
  labelKey: PropTypes.string,
  summary: PropTypes.node,
  expanded: PropTypes.bool,
  status: PropTypes.string,
  errorKey: PropTypes.string,
  onToggle: PropTypes.func,
  onRetry: PropTypes.func,
  children: PropTypes.node
}

export default FootprintExpandableRow
